export const CONFIGURATION_BASE_PATH = "/config/v1";
export const CONFIGURATION_EXPORT_PATH = "/export";
export const CONFIGURATION_IMPORT_PATH = "/import";
export const CONFIGURATION_PRODUCT_QUERY = "product=Lighthouse%20Storage";
export const ATTRIBUTE_DISPLAY_NAME_MIN_LENGTH = 1;
export const ATTRIBUTE_DISPLAY_NAME_MAX_LENGTH = 50;
